import styled from 'styled-components';

const Container = styled.div``;

export default function TestPagePresenter() {

  return (
    <Container>TestPage</Container>
  );
}
